import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Inject,
  Optional
} from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

declare let toastr: any;

@Component({
    selector: "change-user-password",
    templateUrl: "./change-user-password.component.html",
    styleUrls: ["./change-user-password.component.scss"],
    standalone: true,
    imports: [ReactiveFormsModule]
})
export class ChangeUserPasswordComponent implements OnInit {
  form: UntypedFormGroup;
  randomPassword: string = null;
  attemptedSubmit = false;
  @Input() user = null;
  @Input() showGeneratePassword: boolean;
  @Output() close = new EventEmitter();
  @Output() submit = new EventEmitter<{ password: string; id: string }>();

  constructor(
    private builder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<ChangeUserPasswordComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const { user, showGeneratePassword } = this.data;
    this.user = user;
    this.showGeneratePassword = showGeneratePassword;
    this.form = this.builder.group({
      new_password: [null, [Validators.required, Validators.minLength(8)]]
    });
  }

  closeModal() {
    this.resetModal();
    this.close.emit();
    this.dialogRef.close(null);
  }

  generatePassword() {
    this.randomPassword = Math.random()
      .toString(36)
      .slice(-8);
    this.form.controls.new_password.setValue(this.randomPassword);
  }

  resetModal() {
    this.form.reset();
    this.attemptedSubmit = false;
    this.randomPassword = null;
  }

  submitForm() {
    console.log("Am submitting");
    this.attemptedSubmit = true;
    if (this.form.valid) {
      this.submit.emit({
        password: this.form.controls.new_password.value,
        id: this.user.id
      });
      this.dialogRef.close({
        password: this.form.controls.new_password.value,
        id: this.user.id
      });
      this.resetModal();
    } else {
      toastr.error("", "Password is invalid.", {
        timeOut: 2000
      });
    }
  }

  copiedSuccess() {
    toastr.success("", "Copied to clipboard.", {
      timeOut: 2000
    });
  }

  ngOnInit() {}
}
